import React from 'react';
import { PhoneIncomingIcon } from 'lucide-react';
import { Pulse, Reveal } from './Reveal';
import { VignetteFrame } from './VignetteFrame';
const transcript: {
  speaker: string;
  line: string;
  self: boolean;
}[] = [{
  speaker: 'Viridia AI',
  self: true,
  line: 'Hi, thanks for calling the Ramirez Group. Are you calling about a home you saw online?'
}, {
  speaker: 'Caller',
  self: false,
  line: 'Yeah, the listing on East Cactus. Is it still available?'
}];
const chips: string[] = ['Buyer', '$600k to $750k', 'Pre-approved', 'Wants to tour Saturday'];
export function CallVignette() {
  return <VignetteFrame label="Live call" timestamp="9:42 PM" data-id="element-255" data-mp="3eswgsbjuutl1">
      <Reveal className="flex items-center justify-between gap-4 rounded-xl border border-brand/30 bg-brand/10 px-4 py-3" data-id="element-256" data-mp="39ta2rzw7d9b6">
        <div className="flex items-center gap-3" data-id="element-257" data-mp="1czp1h248sbz5">
          <PhoneIncomingIcon className="h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-258" data-mp="1cydyv5mj9a9m" />
          <div data-id="element-259" data-mp="17zkhh244kz46">
            <p className="text-sm font-semibold text-white" data-id="element-260" data-mp="b7fsfcayngcw">Zillow lead line</p>
            <p className="text-xs text-white/50" data-id="element-261" data-mp="b9isyq9qorvv">Incoming call</p>
          </div>
        </div>
        <Pulse data-id="element-262" data-mp="face5bvsrsl2" />
      </Reveal>

      <Reveal delay={0.15} className="mt-4 flex items-center justify-between gap-4" data-id="element-263" data-mp="19i5qt8r1rme">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-brand" data-id="element-264" data-mp="1bl35yc8en15">
          Answered by Viridia AI
        </p>
        <p className="text-sm font-semibold tabular-nums text-white/70" data-id="element-265" data-mp="txe3m1a21pkr">00:03</p>
      </Reveal>

      <div className="mt-4 space-y-3" data-id="element-266" data-mp="yxihrknhq87t">
        {transcript.map((entry, index) => <Reveal key={entry.line} delay={0.3 + index * 0.25} offset={10} data-id="element-267" data-mp="k8dye04ylxy4" data-mpi={index}>
            <div className={`max-w-[92%] rounded-xl border px-4 py-3 ${entry.self ? 'border-white/10 bg-ink-700' : 'ml-auto border-brand/25 bg-brand/10'}`} data-id="element-268" data-mp="k69xzs69rh2l">
              <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-white/40" data-id="element-269" data-mp="1hojq2zai3g41">
                {entry.speaker}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-white/80" data-id="element-270" data-mp="1rh4i8grkrj8t">{entry.line}</p>
            </div>
          </Reveal>)}
      </div>

      <div className="mt-5 border-t border-white/10 pt-4" data-id="element-271" data-mp="1hk9jbwre3gu0">
        <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-white/40" data-id="element-272" data-mp="1djpo4yqdmnai">
          Qualified
        </p>
        <ul className="mt-3 flex flex-wrap gap-2" data-id="element-273" data-mp="18l4nwzb4k3m2">
          {chips.map((chip, index) => <li key={chip} data-id="element-274" data-mp="13te7qcpialmq" data-mpi={index}>
              <Reveal delay={0.85 + index * 0.12} offset={8} data-id="element-275" data-mp="13t4g6kotc6ex">
                <span className="inline-block rounded-full border border-brand/30 bg-brand/10 px-3 py-1 text-xs font-medium text-brand" data-id="element-276" data-mp="yujo58jpst1k">
                  {chip}
                </span>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </VignetteFrame>;
}